export default __webpack_public_path__ + "static/media/h_wdt_c_1_2.31d5f9a9.mp3";